<table border="0" cellpadding="4" cellspacing="4" style="width: 99%; margin: 0 auto;">
  <tbody>
    <tr *ngIf="error">
      <td>
        <div id="errors">
          <br><br>
          <b>
            <font color="red">{{ error }}</font>
          </b>
        </div>
      </td>
    </tr>

    <tr *ngIf="loading && !event">
      <td align="center">
        <p>Loading event information...</p>
      </td>
    </tr>
    <tr *ngIf="checkingCallPlan">
      <td align="center" colspan="2">
        <p>Verifying your information...</p>
      </td>
    </tr>

    <tr *ngIf="!loading">
      <td id="top-paragraph" align="center">
        Please join us for this {{ event && event.meeting_type?.includes('Virtual') ? 'virtual ' : '' }}live educational program hosted by CSL Behring and presented by a member of the <i>SHARE Nurse Training</i> Speaker Program.
        <br/><br/>
        This program is intended for healthcare professionals and select office staff only&mdash;spouses, guests, and children are not permitted to attend. This is not a CME program.
        <br/><br/>
        Due to mandatory government reporting obligations of the 2010 Patient Protection and Affordable Care Act<br> ("Open Payments-Programs Sunshine Act"), payments or transfers of value made to covered recipients will be reported to CMS. Additional state restrictions and disclosure requirements may also apply.
        <br/><br/>
        <i>
          As of January 1, 2022, PhRMA Code prohibits its members from providing alcoholic beverages at speaker programs, if applicable. Additionally, the wait staff cannot take your order for alcohol. You are, however, welcome to purchase your own drink at the bar and bring it into the meeting room. We appreciate your understanding.
        </i>
      </td>
    </tr>

    <tr *ngIf="event && !loading">
      <td>
        <b>Program Title: </b>
        <span>{{ event.topic || 'N/A' }}</span>
        <br>
        <b>Speaker:</b>
        <span *ngIf="event.speaker">
          {{ event.speaker.full_name }}<span *ngIf="event.speaker.degrees">, {{ event.speaker.degrees }}</span>
        </span>
        <span *ngIf="!event.speaker">N/A</span>

        <br/>

        <b>Date:</b>
        {{ event.friendly_date || 'N/A' }}<br/>
        <b>Time:</b>
        <span *ngIf="event.meeting_type && !event.meeting_type.includes('Virtual')">
          {{ formatEventTime() }} <span *ngIf="event.timezone">{{ event.timezone }}</span><br/>
        </span>
        <span *ngIf="event.meeting_type && event.meeting_type.includes('Virtual')">
          {{ formatEventTime() }}<br>
        </span>
        <span *ngIf="!event.meeting_type">
          {{ formatEventTime() }}<br>
        </span>
      </td>
    </tr>

    <tr *ngIf="event && !loading && event.meeting_type && !event.meeting_type.includes('Virtual')">
      <td align="left" valign="top">
        <b>Location:</b>  <strong><a id="location-link" target="_blank" [href]="event.venue?.google_maps_uri || ''" style="text-decoration: none; color: inherit;">{{ event.venue_name }}</a></strong> <br/>
        <span *ngIf="event.venue?.address1 || event.venue_city">
          <span *ngIf="event.venue?.address1">{{ event.venue?.address1 }}<span *ngIf="event.venue?.address2">, {{ event.venue?.address2 }}</span>, </span>
          <span *ngIf="event.venue_city">{{ event.venue_city }}, {{ event.venue_state }}  {{ event.venue_zip }}</span>
          <br/>
        </span>
        <b>Phone:</b> <strong>{{ event.venue?.general_phone || '' }}</strong><br/>
      </td>
    </tr>

    <tr *ngIf="event && !loading">
      <td align="left" valign="top">
        <div *ngIf="event.meeting_type === 'Virtual'" style="text-align: center">
          <strong>{{ event.speaker ? event.speaker.full_name : 'N/A' }}</strong>
        </div>
        <div *ngIf="event.meeting_type === 'Virtual'" style="text-align: center; text-decoration-line: underline">
          <strong>{{ event.topic }}</strong>
        </div>
        <div *ngIf="event.meeting_type === 'Virtual'" style="text-align: center">
          <strong>{{ event.friendly_date }} at </strong>
          <strong>{{ formatEventTime() }}<br></strong>
        </div>
        <br>
        <form *ngIf="!event.below_cap" enctype="multipart/form-data" [formGroup]="registrationForm" (ngSubmit)="step === 1 ? onStep1Submit($event) : onStep2Submit($event)">
          <input type="hidden" formControlName="step">
          <input type="hidden" formControlName="auto_populate">
          <input type="hidden" formControlName="compass_id">
          <table id="create-attendee">
            <caption>
              <span *ngIf="step === 1">
                Please complete the following registration form. There is no fee for this educational activity.<br>
              </span>
              <span *ngIf="step === 2">
                {{ callPlanData ? 'Please review, update as needed, and complete any missing information on the registration form.' : 'Please complete the registration form.' }}<br>
              </span>
              <span style="color: black;">*</span>Required Field
            </caption>
            <!-- Dynamic Questions from Platform -->
            <tbody *ngIf="useDynamicQuestions && registrationQuestions.length > 0">
              <ng-container *ngFor="let eq of registrationQuestions">
                <tr *ngIf="eq.question && isQuestionVisible(eq)" [style.display]="isQuestionVisible(eq) ? 'table-row' : 'none'">
                  <th [class]="(isQuestionRequired(eq) && eq.question && registrationForm.get(getQuestionControlName(eq.question.id))?.invalid && registrationForm.get(getQuestionControlName(eq.question.id))?.touched) ? 'errmsg' : 'normal'">
                    <span *ngIf="isQuestionRequired(eq)">*</span>{{ eq.question.text }}
                  </th>
                  <td *ngIf="eq.question">
                    <!-- TEXT_FIELD -->
                    <ng-container *ngIf="eq.question.type_id === 'TEXT_FIELD'">
                      <input type="text" [formControlName]="getQuestionControlName(eq.question.id)" [name]="'question_' + eq.question.id">
                    </ng-container>
                    
                    <!-- DROPDOWN -->
                    <ng-container *ngIf="eq.question.type_id === 'DROPDOWN'">
                      <select [formControlName]="getQuestionControlName(eq.question.id)" [name]="'question_' + eq.question.id">
                        <option value="">Select...</option>
                        <option *ngFor="let choice of getQuestionChoices(eq.question)" [value]="choice">{{ choice }}</option>
                      </select>
                    </ng-container>
                    
                    <!-- MULTIPLE_CHECK - Multiple Select -->
                    <ng-container *ngIf="eq.question.type_id === 'MULTIPLE_CHECK'">
                      <select [formControlName]="getQuestionControlName(eq.question.id)" [name]="'question_' + eq.question.id" multiple style="min-height: 100px;">
                        <option *ngFor="let choice of getQuestionChoices(eq.question)" [value]="choice">{{ choice }}</option>
                      </select>
                    </ng-container>
                    
                    <!-- MULTIPLE_RADIO -->
                    <ng-container *ngIf="eq.question.type_id === 'MULTIPLE_RADIO'">
                      <div *ngFor="let choice of getQuestionChoices(eq.question)">
                        <label>
                          <input type="radio" [formControlName]="getQuestionControlName(eq.question.id)" [value]="choice" [name]="'question_' + eq.question.id">
                          {{ choice }}
                        </label>
                      </div>
                    </ng-container>
                    
                    <!-- CHECKBOX -->
                    <ng-container *ngIf="eq.question.type_id === 'CHECKBOX'">
                      <div *ngFor="let choice of getQuestionChoices(eq.question)">
                        <label>
                          <input type="checkbox" [value]="choice" [checked]="isChoiceSelected(eq.question.id, choice)" (change)="onCheckboxChange(eq.question!.id, choice, $event)">
                          {{ choice }}
                        </label>
                      </div>
                    </ng-container>
                    
                    <!-- YN (Yes/No) -->
                    <ng-container *ngIf="eq.question.type_id === 'YN'">
                      <select [formControlName]="getQuestionControlName(eq.question.id)" [name]="'question_' + eq.question.id">
                        <option [value]="null">Select...</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </ng-container>
                    
                    <!-- TF (True/False) -->
                    <ng-container *ngIf="eq.question.type_id === 'TF'">
                      <select [formControlName]="getQuestionControlName(eq.question.id)" [name]="'question_' + eq.question.id">
                        <option [value]="null">Select...</option>
                        <option value="True">True</option>
                        <option value="False">False</option>
                      </select>
                    </ng-container>
                    
                    <!-- COMMENTS -->
                    <ng-container *ngIf="eq.question.type_id === 'COMMENTS'">
                      <textarea [formControlName]="getQuestionControlName(eq.question.id)" [name]="'question_' + eq.question.id" rows="4"></textarea>
                    </ng-container>
                    
                    <!-- NUMBER -->
                    <ng-container *ngIf="eq.question.type_id === 'NUMBER'">
                      <input type="number" [formControlName]="getQuestionControlName(eq.question.id)" [name]="'question_' + eq.question.id">
                    </ng-container>
                    
                    <!-- DATE -->
                    <ng-container *ngIf="eq.question.type_id === 'DATE'">
                      <input type="date" [formControlName]="getQuestionControlName(eq.question.id)" [name]="'question_' + eq.question.id">
                    </ng-container>
                    
                    <!-- PHONE_NUMBER -->
                    <ng-container *ngIf="eq.question.type_id === 'PHONE_NUMBER'">
                      <input type="tel" [formControlName]="getQuestionControlName(eq.question.id)" [name]="'question_' + eq.question.id">
                    </ng-container>
                    
                    <!-- HEADER or PARAGRAPH (display only) -->
                    <ng-container *ngIf="eq.question.type_id === 'HEADER' || eq.question.type_id === 'PARAGRAPH'">
                      <div [innerHTML]="eq.question.text"></div>
                    </ng-container>
                  </td>
                </tr>
                <!-- Confirm field row -->
                <ng-container *ngIf="eq.question">
                  <tr *ngIf="eq.question.confirm && isQuestionVisible(eq)">
                    <th [class]="(isConfirmRequired(eq) && registrationForm.get('confirm_question_' + eq.question.id)?.touched && !registrationForm.get('confirm_question_' + eq.question.id)?.value) ? 'errmsg' : 'normal'">
                      <span *ngIf="isConfirmRequired(eq)">*</span>Confirm {{ eq.question.text }}
                    </th>
                    <td>
                      <!-- Match the same input type as the original question -->
                      <ng-container *ngIf="eq.question.type_id === 'TEXT_FIELD' || eq.question.type_id === 'PHONE_NUMBER'">
                        <input [type]="eq.question.type_id === 'PHONE_NUMBER' ? 'tel' : 'text'" [formControlName]="'confirm_question_' + eq.question.id">
                      </ng-container>
                      <ng-container *ngIf="eq.question.type_id === 'NUMBER'">
                        <input type="number" [formControlName]="'confirm_question_' + eq.question.id">
                      </ng-container>
                      <ng-container *ngIf="eq.question.type_id === 'DATE'">
                        <input type="date" [formControlName]="'confirm_question_' + eq.question.id">
                      </ng-container>
                      <ng-container *ngIf="eq.question.type_id === 'DROPDOWN'">
                        <select [formControlName]="'confirm_question_' + eq.question.id">
                          <option value="">Select...</option>
                          <option *ngFor="let choice of getQuestionChoices(eq.question)" [value]="choice">{{ choice }}</option>
                        </select>
                      </ng-container>
                      <ng-container *ngIf="eq.question.type_id === 'COMMENTS'">
                        <textarea [formControlName]="'confirm_question_' + eq.question.id" rows="4"></textarea>
                      </ng-container>
                      <ng-container *ngIf="eq.question.type_id !== 'TEXT_FIELD' && eq.question.type_id !== 'PHONE_NUMBER' && eq.question.type_id !== 'NUMBER' && eq.question.type_id !== 'DATE' && eq.question.type_id !== 'DROPDOWN' && eq.question.type_id !== 'COMMENTS'">
                        <input type="text" [formControlName]="'confirm_question_' + eq.question.id">
                      </ng-container>
                      <div *ngIf="getConfirmError(eq)" style="color: red; font-size: 11px; margin-top: 2px;">
                        {{ getConfirmError(eq) }}
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2">
                  <p>
                    By submitting this form, you are consenting to disclose any information you provide, including your name, email address, address, telephone number, and any other information (collectively "Personal Information") to CSL Behring and its representatives, agents, and contractors (collectively "CSL Behring Entities"), and to receive communications with relevant information about the event for which you registered, from CSL Behring Entities. In the future, you may also receive information and advertisements, including marketing information, from CSL Behring Entities by mail, email or telephone to provide information or to offer enrollment in educational programs, and programs intended to benefit patients using or eligible to use CSL Behring therapies. You will have the ability, at any time, to opt out from receiving communications from CSL Behring Entities. CSL Behring and CSL Entities will not sell your personal information.
                  </p>
                  <p>
                    CSL Behring respects your privacy. For an explanation of how CSL Behring will use the information you are submitting, please view our <a href="https://privacy.csl.com">Privacy Policy</a>.
                  </p>
                </td>
              </tr>
              <tr>
                <td align="center" colspan="2"><br/><button class="btn btn-primary" style="font-weight: bold;" type="submit">{{ (step === 1 && !useDynamicQuestions) ? 'Continue' : 'Submit' }}</button></td>
              </tr>
            </tfoot>
          </table>
        </form>
        <table *ngIf="event && event.below_cap" id="create-attendee">
          <caption>
            Due to an overwhelming response, the program you are trying to register for is currently full. At this time we are unable to register you for this program. If additional space becomes available or you would like to be notified of upcoming programs in your area, please email your name, degree, affiliation, contact information and program number for which you are currently trying to register to <a href="mailto:CSL.Program@trio-hc.com">CSL.Program@trio-hc.com</a>.<br><br>
            Thank you.
          </caption>
        </table>
      </td>
    </tr>
  </tbody>
</table>

<!-- Call Plan Confirmation Modal -->
<div *ngIf="confirmDialogVisible" 
     style="position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; background-color: rgba(0, 0, 0, 0.6) !important; z-index: 10000 !important; display: flex !important; align-items: center !important; justify-content: center !important;"
     (click)="$event.stopPropagation()">
  <div style="background-color: white !important; padding: 30px !important; border-radius: 8px !important; max-width: 500px !important; width: 90% !important; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5) !important; position: relative !important;" 
       (click)="$event.stopPropagation()">
    <h3 style="margin-top: 0 !important; margin-bottom: 20px !important; color: #7A0032 !important; font-weight: bold !important; font-size: 18px !important;">Confirm Your Information</h3>
    <p id="info" style="font-size: 14px !important; margin: 20px 0 !important; line-height: 1.6 !important;">
      <strong style="color: #333 !important;">Is this you?</strong><br><br>
      <span *ngIf="callPlanData" style="color: #333 !important;">
        <strong>{{ callPlanData.first_name }} {{ callPlanData.last_name }}</strong><br>
        {{ callPlanData.city }}, {{ callPlanData.state }}
      </span>
    </p>
    <div style="text-align: center !important; margin-top: 30px !important;">
      <button id="confirm" 
              (click)="confirmCallPlan()" 
              type="button"
              style="background-color: #790033 !important; color: white !important; border: none !important; padding: 12px 30px !important; margin: 0 10px !important; cursor: pointer !important; border-radius: 4px !important; font-weight: bold !important; font-size: 14px !important; min-width: 120px !important;">
        Yes, this is me
      </button>
      <button id="cancel" 
              (click)="cancelCallPlan()" 
              type="button"
              style="background-color: #ccc !important; color: #333 !important; border: none !important; padding: 12px 30px !important; margin: 0 10px !important; cursor: pointer !important; border-radius: 4px !important; font-weight: bold !important; font-size: 14px !important; min-width: 120px !important;">
        This is not me
      </button>
    </div>
  </div>
</div>
